import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackPixelEvent } from '../hooks/useMetaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  size?: 'md' | 'lg' | 'xl';
  href?: string;
  className?: string;
}
export function CtaButton({
  children,
  variant = 'primary',
  size = 'lg',
  href = '#planes',
  className = ''
}: CtaButtonProps) {
  const base = 'group inline-flex items-center justify-center gap-3 rounded-2xl text-center font-display font-extrabold uppercase tracking-tight transition-[transform,background-color,box-shadow,color] duration-150 ease-calm focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-blue-300 active:translate-y-px';
  const sizes = {
    md: 'px-6 py-3.5 text-sm',
    lg: 'px-8 py-4 text-base md:text-lg',
    xl: 'px-8 py-5 text-lg md:text-2xl'
  };
  const variants = {
    primary: 'bg-blue-600 text-white shadow-lift hover:bg-blue-700',
    secondary: 'bg-white text-blue-700 ring-2 ring-inset ring-blue-200 hover:bg-blue-50'
  };
  const isCheckout = href.startsWith('http');
  const handleClick = () => {
    if (isCheckout) {
      trackPixelEvent('InitiateCheckout', {
        content_name: 'Atlas Kinesio-Visual',
        value: 13.9,
        currency: 'USD'
      });
    }
  };
  return <a href={href} onClick={handleClick} className={`${base} ${sizes[size]} ${variants[variant]} ${className}`} data-id="element-65" data-mp="3jxyrk0pv3n64">
      <span data-id="element-66" data-mp="3otxnqahfm9h3">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-calm group-hover:translate-x-1 md:h-6 md:w-6" aria-hidden="true" data-id="element-67" data-mp="3sxdif19xxzr5" />
    </a>;
}